import React, { useEffect, useState } from 'react'
import CardCustom from '../custom/card-custom'
import { BsPersonFill } from 'react-icons/bs'
import { Col } from 'react-bootstrap'
import moment from 'moment'
import styled from 'styled-components'
import { getDashboardOrgAPI } from '../../services/dashboard'

export default function SkyGroupLayout() {
  const [totalOrg, setTotalOrg] = useState([])
  useEffect(() => {
    const getDashboardOrg = async () => {
      try {
        const resp = await getDashboardOrgAPI()
        if (!resp) return
        if (resp.status) {
          setTotalOrg(resp.result)
        }
      } catch (error) {
        setTotalOrg([])
      }
    }
    getDashboardOrg()
  }, [])

  return (
    <>
      <Col md={3} className="mb-3">
        <CardCustom className="h-100" minHeight="none">
          <div className="p-3">
            <h5 className="mb-0">Sky Group</h5>
            <p className="small fw-light">Total Employee</p>

            <h2 className="mb-2 pt-1">
              {' '}
              <BsPersonFill size={20} className="me-2" />
              {totalOrg.length > 0
                ? totalOrg
                    .map((d) => d.counts)
                    .reduce((a, b) => a + b, 0)
                    .toLocaleString()
                : '-'}
            </h2>
          </div>
        </CardCustom>
      </Col>
      <Col md={9} className="mb-3">
        <CardCustom minHeight="none">
          <div className="p-3">
            <div className="d-flex justify-content-between mb-3">
              <h5 className="mb-0">Employee by company</h5>
              <span className="fw-light font-small-2 text-muted">
                Data as of {moment(new Date()).format('DD MMMM YYYY, HH:mm')}{' '}
                am.
              </span>
            </div>

            <BoxImage className="">
              {totalOrg.length > 0 &&
                totalOrg.map((d, i) => (
                  <div key={i} className="mt-4">
                    <div className="d-flex">
                      <div
                        style={{ width: 45, height: 45 }}
                        className="rounded-circle d-flex justify-content-center align-items-center bg-body-secondary small text-primary-emphasis"
                      >
                        {Math.round(
                          (d.counts /
                            totalOrg
                              .map((d) => d.counts)
                              .reduce((a, b) => a + b, 0)) *
                            100
                        )}
                        %
                      </div>

                      <div className="ps-3 my-auto">
                        <h5 className="mb-0"> {d.counts.toLocaleString()}</h5>
                        <span className="fw-light font-small-2  text-muted">
                          {d.org}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
            </BoxImage>
          </div>
        </CardCustom>
      </Col>
    </>
  )
}

const BoxImage = styled.div`
  display: grid;
  gap: 1rem;
  flex-wrap: wrap;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
`
